"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORGANISATION_STATUS_OPTIONS = void 0;

var _organisationStatus = require("./organisationStatus");

var ORGANISATION_STATUS_OPTIONS = [{
  label: 'Active',
  value: _organisationStatus.ORGANISATION_STATUS.ACTIVE
}, {
  label: 'Archived',
  value: _organisationStatus.ORGANISATION_STATUS.ARCHIVED
}];
exports.ORGANISATION_STATUS_OPTIONS = ORGANISATION_STATUS_OPTIONS;